import { Environment } from '@src/environment';
import { UserRole } from '@funnellab/shared/src/dtos/UserDTO';
import type { User } from '@src/api/services/AuthenticationService';

export const jobCopyFeatureFlag = (user: User) => {
  return (
    !Environment.isProd ||
    user.role === UserRole.ADMINISTRATOR ||
    user.role === UserRole.AGENCY
  );
};
